<template>
  <index_layout>
    <magznav class="nav"></magznav>
    <div class="brands">
      <loading :active.sync="loading" loader="bars" color="#00ab00"></loading>
      <template v-for="brand in brands">
        <span :key="brand.brandCode" @click="navto(brand)" class="actable">
          <div class="card">
            <image-loader class="cover" :src="brandCover(brand)" />
            <div class="bottombar">
              <span class="title">{{ brand.issuerName }}</span>
              <span class="iconfont iconheart collect"></span>
            </div>
          </div>
        </span>
      </template>
    </div>
    <template v-slot:ft>
      <mfooter @changelcid="reload"></mfooter>
    </template>
  </index_layout>
</template>
<script>
import index_layout from "../_layout/index_layout";
import MagzNav from "../MagzNav";
import Footer from "../Footer";
import { get } from "../../libs/request";
import { API } from "../../libs/consts";
import * as utils from "../../libs/utils";

export default {
  components: {
    index_layout: index_layout,
    mfooter: Footer,
    magznav: MagzNav,
  },
  data() {
    return {
      pgInd: 1,
      pgLen: 8,
      hasmore: true,
      loading: false,
      brands: [],
    };
  },
  computed: {
    subject() {
      return this.$route.query.s;
    },
  },
  created() {
    this.loadMags();
    window.addEventListener("scroll", this.scroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.scroll);
  },
  methods: {
    reload() {
      this.pgInd = 1;
      this.brands = [];
      this.hasmore = true;
      this.loadMags();
    },
    loadMags() {
      if (!this.hasmore || this.loading) return;
      this.loading = true;
      get(API.magz.brand.page, {
        pgInd: this.pgInd,
        pgLen: this.pgLen,
        sid: this.subject,
      })
        .then((rps) => {
          if (rps.errMsg == API.Code.ok) {
            const result = rps.data;
            this.brands.push(...result.list);
            if (result.pageTotal > this.pgInd) {
              this.pgInd += 1;
            } else {
              this.hasmore = false;
            }
          } else {
            console.log(rps);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    scroll() {
      //window 1%的误差
      if (
        utils.scrollFix(utils.getScrollHeight()) ==
        utils.scrollFix(utils.getWindowHeight() + utils.getDocumentTop())
      ) {
        this.loadMags();
      }
    },
    brandCover: (brand) => (brand.lastIssue ? brand.lastIssue[0].cover : ""),
    lastIssue: (brand) => (brand.lastIssue ? brand.lastIssue[0] : {}),
    navto(brand) {
      utils.setBackPath(utils.MAGZ_BACK_PATH_KEY, this.$route.fullPath);
      this.$router.push(
        `/mag/${brand.brandCode}/${this.lastIssue(brand).issueId}`
      );
    },
  },
  watch: {
    subject() {
      this.reload();
    },
  },
};
</script>
<style scoped src="./index.css" />